import { environment } from '~env/environment';

export const PRODUCT_PLACEHOLDER_URL = () => `${environment.cdnBaseUrl()}/images/product-catalog-placeholder.png`;
